// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExpandAltOutlinedSvg from "@ant-design/icons-svg/es/asn/ExpandAltOutlined";
import AntdIcon from '../components/AntdIcon';

var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExpandAltOutlinedSvg
  }));
};

ExpandAltOutlined.displayName = 'ExpandAltOutlined';
export default React.forwardRef(ExpandAltOutlined);